import { useState } from "react";
import { AnimatePresence, motion } from "motion/react";

export default function MediaGallery({ items }) {
  const [active, setActive] = useState(0);
  const current = items[active];

  return (
    <div className="project-stage">
      <div className="project-main-image">
        <AnimatePresence mode="wait">
          <motion.img
            key={current.src}
            src={current.src}
            alt={current.alt}
            loading="lazy"
            initial={{ opacity: 0.2, scale: 1.02 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0.2 }}
            transition={{ duration: 0.38 }}
          />
        </AnimatePresence>
        <span>Imagem meramente ilustrativa</span>
      </div>
      <div className="gallery-thumbs" aria-label="Perspectivas do projeto">
        {items.map((item, index) => (
          <button
            className={index === active ? "is-active" : ""}
            type="button"
            key={item.src}
            aria-label={`Ver perspectiva ${index + 1}`}
            aria-pressed={index === active}
            onClick={() => setActive(index)}
          >
            <img src={item.src} alt="" loading="lazy" />
          </button>
        ))}
      </div>
    </div>
  );
}
